import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { cognitoUserPoolsTokenProvider } from "aws-amplify/auth/cognito";
import { CookieStorage } from "aws-amplify/utils";
import { Amplify } from "aws-amplify";
import App from "./app";
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary";
import "./index.css";
import AuthGate from "./components/AuthGate";
import { store } from "./store";
import { Provider } from "react-redux";
import NotificationsOverlay from "./components/NotificationOverlay";

cognitoUserPoolsTokenProvider.setKeyValueStorage(
  new CookieStorage({
    domain: ".getsmarteye.mobi",
    path: "/",
    expires: 365,
    sameSite: "lax",
    secure: true,
  })
);

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
      userPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
      loginWith: {
        oauth: {
          domain: import.meta.env.VITE_COGNITO_DOMAIN,
          scopes: [
            "aws.cognito.signin.user.admin",
            "email",
            "openid",
            "profile",
          ],
          redirectSignIn: [import.meta.env.VITE_COGNITO_REDIRECT_SIGN_IN],
          redirectSignOut: [import.meta.env.VITE_COGNITO_REDIRECT_SIGN_OUT],
          responseType: "code",
        },
      },
    },
  },
} as any);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <ErrorBoundary>
          <AuthGate>
            <NotificationsOverlay />
            <App />
          </AuthGate>
        </ErrorBoundary>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
